/**
 *  Shop Product Detail Page
 */
import React , {Component} from 'react';
import PostDetail from '../../templates/post-detail';
import ProductSlider from '../../widgets/ProductSlider';
import { Link } from 'react-router-dom';
import { Row, Col,Container,Nav, NavItem, NavLink,TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';


class Detail extends Component {
    componentDidMount() {
       window.scrollTo(0, 0)
     }
    render() {
     return (
          
        <div> <p>mockup</p> </div>
             
             
       )
    }
 }
export default Detail;